/**
 * Ponte entre permissões UpClinic (catálogo pontilhado) e chaves runtime
 * usadas em AuthContext / ProfessionalForm (`patients_view`, `manage_appointments`, …).
 */
export const CATALOG_TO_RUNTIME: Record<string, string[]> = {
  'agendas.gestao': ['appointments_view', 'appointments_edit', 'manage_appointments', 'view_appointments'],
  'agendas.mapa': ['appointments_view', 'view_appointments'],
  'agendas.evolucao': ['ehr_view', 'ehr_edit', 'manage_ehr'],
  'agendas.remarcar': ['appointments_edit', 'manage_appointments'],
  'agendas.editar': ['appointments_edit', 'manage_appointments'],
  'agendas.excluir': ['appointments_delete', 'manage_appointments'],
  'agendas.status': ['appointments_edit', 'manage_appointments'],
  'agendas.status_passados': ['appointments_edit', 'manage_appointments'],
  'agendas.whatsapp': ['appointments_view'],

  'clientes.gestao': ['patients_view', 'patients_edit', 'view_patients', 'manage_patients'],
  'clientes.indicadores': ['patients_view', 'view_patients'],
  'clientes.checkin': ['patients_view'],
  'clientes.lista_espera': ['patients_view'],
  'clientes.lembretes': ['patients_view'],

  'cliente.visao_geral': ['patients_view', 'view_patients'],
  'cliente.financeiro': ['financial_view', 'view_financial'],
  'cliente.pacotes': ['patients_view'],
  'cliente.historico': ['patients_view', 'ehr_view'],
  'cliente.prontuario': ['ehr_view', 'ehr_edit', 'manage_ehr'],
  'cliente.multimidia': ['ehr_view', 'ehr_edit'],
  'cliente.atestados': ['ehr_view', 'ehr_edit'],
  'cliente.contratos': ['patients_view'],
  'cliente.produtos': ['patients_view'],

  'cad.precos': ['financial_view', 'financial_edit'],
  'cad.convenios': ['patients_view'],
  'cad.profissionais': ['professionals_view', 'manage_professionals'],

  'fin.gestao': ['financial_view', 'financial_edit', 'manage_financial', 'view_financial'],
  'fin.caixa': ['financial_view', 'manage_financial'],
  'fin.relatorios': ['financial_view', 'view_financial'],

  'ger.usuarios': ['admin_access', 'manage_users'],
  'ger.permissoes': ['admin_access', 'manage_users'],
  'ger.config': ['admin_access'],

  'relatorios.geral': ['reports_view', 'view_reports'],
  'rel.geral': ['reports_view', 'view_reports'],
  'rel.financeiro': ['reports_view', 'financial_view', 'view_reports'],
  'rel.agenda': ['reports_view', 'appointments_view', 'view_reports'],

  'mkt.gestao': ['marketing_view', 'marketing_edit'],
  'mkt.campanhas': ['marketing_view', 'marketing_edit'],
  'mkt.mensagens': ['marketing_view'],

  'cad.produtos': ['inventory_view', 'inventory_edit'],
  'cad.servicos': ['financial_view', 'financial_edit'],

  'homecare.campo': ['homecare_field_access'],
  'homecare.rotas': ['homecare_manage_routes', 'homecare_view_all'],
  'homecare.admin': ['homecare_admin_settings', 'homecare_view_all'],
};

/** Expande chaves do catálogo UpClinic para o dialeto runtime (e mantém as originais). */
export function expandPermissionKeys(keys: string[]): string[] {
  const out = new Set<string>();
  for (const key of keys) {
    if (!key) continue;
    out.add(key);
    const mapped = CATALOG_TO_RUNTIME[key];
    if (mapped) mapped.forEach((k) => out.add(k));
    // Prefixos genéricos
    if (key.startsWith('agendas.')) {
      out.add('appointments_view');
      out.add('manage_appointments');
    }
    if (key.startsWith('cliente.') || key.startsWith('clientes.')) {
      out.add('patients_view');
      out.add('view_patients');
    }
    if (key.startsWith('fin.')) {
      out.add('financial_view');
      out.add('view_financial');
    }
    if (key.startsWith('homecare.')) {
      out.add('homecare_field_access');
    }
  }
  return [...out];
}
